module.exports = new __parcel__URL__("no-results.603cf20f.svg").toString();